exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".submit_from_PortalCheckoutYearsSelection-css_3JQ {\n  margin-top: 24px;\n  text-align: right;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  gap: 20px;\n}\n", ""]);

// exports
exports.locals = {
	"submit": "submit_from_PortalCheckoutYearsSelection-css_3JQ"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--3-1!./node_modules/postcss-loader/lib??ref--3-2!./app/web/src/routes/portal/PortalCheckout/PortalCheckoutYearsSelection.css
// module id = ./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/portal/PortalCheckout/PortalCheckoutYearsSelection.css
// module chunks = 0